// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1p5DB","itemTitle":"ClientEmergencyInfo_itemTitle__ypYJw","itemText":"ClientEmergencyInfo_itemText__F6Gne"};